import { Box, Tooltip } from '@mui/material';

export const ArrayItemRendererWithCutOff = <T,>({
  items,
  renderItem,
  cutOffLimit,
  renderRemainingItems,
  getKey,
}: {
  renderItem: (args: { item: T }) => JSX.Element;
  items: T[];
  cutOffLimit: number;
  renderRemainingItems?: (args: { remainingItems: T[] }) => JSX.Element;
  getKey?: (item: T, index: number) => string | number;
}) => {
  const itemsToRender = items.slice(0, cutOffLimit);
  const remainingItems = items.slice(cutOffLimit);

  // Default key function uses index if no getKey provided
  const keyFn = getKey || ((_, index) => index);

  return (
    <Box display={'flex'} alignItems={'center'}>
      {itemsToRender.map((item, index) => (
        <span key={keyFn(item, index)}>{renderItem({ item })}</span>
      ))}
      {remainingItems.length > 0 ? (
        <Tooltip
          placement="top-start"
          title={
            <div>
              {remainingItems.map((item, index) => (
                <span key={keyFn(item, cutOffLimit + index)}>{renderItem({ item })}</span>
              ))}
            </div>
          }
        >
          <span>{renderRemainingItems ? renderRemainingItems({ remainingItems }) : <></>}</span>
        </Tooltip>
      ) : null}
    </Box>
  );
};
